module.exports = __webpack_public_path__ + "img/banner24.502bd98f.png";